import React from 'react';

import { TextAlignment } from '../../components/ChallengesPage/Settings/challengeSettings/challengeSettings.types';
import { DatePickerInput } from 'wix-ui-tpa/cssVars';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { getDateFromString } from '../../selectors/dates';
import { st, classes } from './DateInput.st.css';
import { isAfter, isSameDay } from 'date-fns';
import { FCWithChildren } from '@wix/challenges-web-library';

export interface IDateInputProps {
  className?: string;
  dataHook?: string;
  defaultValue?: any;
  errorMessage?: string;
  onChange?(value: string): void;
  textAlignment: TextAlignment;
  showError?: boolean;
  minDate?: Date;
}

export const DateInput: FCWithChildren<IDateInputProps> = (props) => {
  const { language } = useEnvironment();
  const currValue = getDateFromString(props.defaultValue);

  return (
    <DatePickerInput
      className={st(
        classes.root,
        {
          textAlignment: props.textAlignment,
        },
        props.className,
      )}
      data-hook={props.dataHook}
      dateInputAriaLabelledby="date-input"
      hasError={props.showError}
      locale={language as any}
      value={currValue}
      onChange={props.onChange}
      errorMessage={props.errorMessage}
      excludePastDates={!props.minDate}
      filterDate={
        props.minDate
          ? (date) => {
              return (
                isSameDay(date, props.minDate) || isAfter(date, props.minDate)
              );
            }
          : null
      }
    />
  );
};
export default DateInput;
